import React from 'react';
import AlloyWheelSelectionImage from '../../../images/Alloy_Car_Image.png';
import { t } from 'i18next';

type CarPart = 'tyre' | 'wheel';

export type CarComponentProps = {
    selectedWheels: string[];
    onWheelSelected: (wheel: string) => void;
    isLeftHandDrive?: boolean;
    type?: CarPart;
};

const Wheel = {
    FrontLeft: 0,
    FrontRight: 1,
    RearLeft: 2,
    RearRight: 3
} as const;

const CarComponent = ({
    selectedWheels,
    type = 'wheel',
    onWheelSelected,
    isLeftHandDrive
}: CarComponentProps): JSX.Element => {
    const onImageClick = (wheel: string) => {
        onWheelSelected(wheel);
    };

    const wheelTranslation = (() => {
        const tyreLeftDrive = {
            [Wheel.FrontLeft]: 'tyre_repair_request.driver_front_tyre',
            [Wheel.FrontRight]: 'tyre_repair_request.passenger_front_tyre',
            [Wheel.RearLeft]: 'tyre_repair_request.driver_rear_tyre',
            [Wheel.RearRight]: 'tyre_repair_request.passenger_rear_tyre'
        };
        const tyreRightDrive = {
            [Wheel.FrontLeft]: 'tyre_repair_request.passenger_front_tyre',
            [Wheel.FrontRight]: 'tyre_repair_request.driver_front_tyre',
            [Wheel.RearLeft]: 'tyre_repair_request.passenger_rear_tyre',
            [Wheel.RearRight]: 'tyre_repair_request.driver_rear_tyre'
        };
        const wheelLeftDrive = {
            [Wheel.FrontLeft]: 'alloy_repair_request.driver_front_wheel',
            [Wheel.FrontRight]: 'alloy_repair_request.passenger_front_wheel',
            [Wheel.RearLeft]: 'alloy_repair_request.driver_rear_wheel',
            [Wheel.RearRight]: 'alloy_repair_request.passenger_rear_wheel'
        };
        const wheelRightDrive = {
            [Wheel.FrontLeft]: 'alloy_repair_request.passenger_front_wheel',
            [Wheel.FrontRight]: 'alloy_repair_request.driver_front_wheel',
            [Wheel.RearLeft]: 'alloy_repair_request.passenger_rear_wheel',
            [Wheel.RearRight]: 'alloy_repair_request.driver_rear_wheel'
        };

        switch (type) {
            case 'tyre':
                return isLeftHandDrive ? tyreLeftDrive : tyreRightDrive;
            default:
                return isLeftHandDrive ? wheelLeftDrive : wheelRightDrive;
        }
    })();

    return (
        <div style={{ height: 400, width: 300 }}>
            <svg style={{ height: 400, width: 300 }}>
                <defs>
                    <pattern
                        id='img1'
                        patternUnits='userSpaceOnUse'
                        x='0'
                        y='0'
                        width='300'
                        height='400'>
                        <image
                            href={AlloyWheelSelectionImage}
                            width='300'
                            height='400'
                        />
                    </pattern>
                </defs>
                <path
                    d='M5,5
        l0,680 l980,0 l0,-680 l-980,0'
                    fill='url(#img1)'
                />
                <circle
                    cx='77'
                    cy='123'
                    r='19'
                    data-testid='passenger-front-circle'
                    className={
                        selectedWheels.includes(
                            t(wheelTranslation[Wheel.FrontLeft])
                        )
                            ? 'wheel-selected'
                            : 'normal'
                    }
                    onClick={() => {
                        onImageClick(t(wheelTranslation[Wheel.FrontLeft]));
                    }}>
                    <title>{t(wheelTranslation[Wheel.FrontLeft])}</title>
                </circle>
                <circle
                    cx='223'
                    cy='123'
                    r='19'
                    data-testid='driver-front-circle'
                    className={
                        selectedWheels.includes(
                            t(wheelTranslation[Wheel.FrontRight])
                        )
                            ? 'wheel-selected'
                            : 'normal'
                    }
                    onClick={() => {
                        onImageClick(t(wheelTranslation[Wheel.FrontRight]));
                    }}>
                    <title>{t(wheelTranslation[Wheel.FrontRight])}</title>
                </circle>
                <circle
                    cx='77'
                    cy='272'
                    r='19'
                    data-testid='passenger-rear-circle'
                    className={
                        selectedWheels.includes(
                            t(wheelTranslation[Wheel.RearLeft])
                        )
                            ? 'wheel-selected'
                            : 'normal'
                    }
                    onClick={() => {
                        onImageClick(t(wheelTranslation[Wheel.RearLeft]));
                    }}>
                    <title>{t(wheelTranslation[Wheel.RearLeft])}</title>
                </circle>
                <circle
                    cx='223'
                    cy='272'
                    r='19'
                    data-testid='driver-rear-circle'
                    className={
                        selectedWheels.includes(
                            t(wheelTranslation[Wheel.RearRight])
                        )
                            ? 'wheel-selected'
                            : 'normal'
                    }
                    onClick={() => {
                        onImageClick(t(wheelTranslation[Wheel.RearRight]));
                    }}>
                    <title>{t(wheelTranslation[Wheel.RearRight])}</title>
                </circle>
            </svg>
        </div>
    );
};

export default CarComponent;
